import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoginAwareComponent } from '../../../../login-aware-component';
import { DiagnosticsServiceFactory } from '../../../../services/diagnostics-service-factory';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { SalesApiService } from '../../services/sales-api.service';

/**
 *
 * */
@Component({
  selector: 'campfire-sales-details-panel',
  templateUrl: './sales-details-panel.component.html',
  styleUrls: ['./sales-details-panel.component.scss']
})
export class SalesDetailsPanelComponent extends LoginAwareComponent implements OnInit, OnDestroy {
  details: any = null;

  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    broadcastService: BroadcastService,
    authService: MsalService,
    private salesApi: SalesApiService) {
    super(diagnosticsFactory.create('LoginComponent'), broadcastService, authService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.salesApi.getDetailsForLob('tours-tmt').subscribe(resp => {
      this.details = resp;
      console.log(this.details);
    });
  }
}
